"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.string.sub.js");

require("core-js/modules/es.array.slice.js");

var _toConsumableArray2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _socket = _interopRequireDefault(require("@/assets/js/socket.js"));

var _stockKline = _interopRequireDefault(require("./components/stock-kline.vue"));

var _stockDeal = _interopRequireDefault(require("./components/stock-deal.vue"));

var _stockMarket = _interopRequireDefault(require("./components/stock-market.vue"));

var _stockTrade = _interopRequireDefault(require("./components/stock-trade.vue"));

var _stockPanel = _interopRequireDefault(require("./components/stock-panel.vue"));

var _InputNumber = _interopRequireDefault(require("@/components/common/InputNumber"));

var _vuex = require("vuex");

var _index = _interopRequireDefault(require("@/store/index"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _stockHistoryOrder = _interopRequireDefault(require("./components/stock-history-order.vue"));

var _order = require("@/model/contractExchange/order.js");

var _index2 = require("@/model/contractExchange/index");

var _settings = require("@/model/settings");

var _message = require("@/components/dialog/message");

var _vueEcharts = _interopRequireDefault(require("vue-echarts"));

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

var _stationSetting = require("@/assets/js/stationSetting");

var _routeSplicing = _interopRequireDefault(require("@/assets/js/routeSplicing"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import Depth from "./components/stock-depth.vue";
//FIXME
//FIXME
var _default = {
  mixins: [_commonMixin.default],
  name: "StockExchange",
  components: {
    Deal: _stockDeal.default,
    Kline: _stockKline.default,
    // Depth,
    Market: _stockMarket.default,
    Panel: _stockPanel.default,
    Trade: _stockTrade.default,
    InputNumber: _InputNumber.default,
    HistoryOrder: _stockHistoryOrder.default,
    "v-chart": _vueEcharts.default
  },
  data: function data() {
    return {
      isSwitchImg: false,
      isSwitch: false,
      currencyValue: null,
      payValue: null,
      incomeValue: null,
      exchangeSureShow: false,
      //换汇确认
      currencyShow: false,
      //是否显示币种选择
      exchangeShow: false,
      //是否显示汇兑弹框
      beforeSure: false,
      tabList: [{
        value: "1",
        label: "盘口"
      }, {
        value: "2",
        label: "实时成交"
      }],
      currIndex: "1",
      multipleNum: 0,
      mixMultipleNum: 1,
      maxMultipleNum: 300,
      dialogVisible: false,
      sliderValue: 0,
      symbol: this.$route.params.symbol || "btcusdt",
      coinFrom: "--",
      coinTo: "--",
      coinInfoMap: {},
      coinItemIdMap: {},
      tradePair: [],
      tradePairArray: [],
      marketList: [],
      assetsInfo: {
        remain: {
          all_u_valuation: {
            usdt: "--"
          },
          list: []
        }
      },
      assetsInfoList: [],
      orderbookList: [{
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }, {
        E: "--",
        T: "--",
        m: "--",
        p: "--",
        q: "--"
      }],
      klineList: [],
      depthList: {
        a: [["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"]],
        b: [["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"]]
      },
      swap_symbol_market: {},
      swap_symbol_id: "",
      old_swap_symbol_id: "",
      from_item_id: "",
      to_item_id: "",
      wsUrl: "",
      token: "",
      pageLoading: false,
      onload: false,
      voucherInterval: null,
      historyDataLength: 0,
      wsContentTime: 0,
      marks: {},
      maxNumber: {},
      marketInfo: {
        last: "",
        currency: {
          cny: ""
        }
      },
      currencyOptions: {
        grid: {
          containLabel: true,
          left: "0%",
          right: "1%",
          bottom: "3%",
          top: "5%"
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#c2c7d0",
            fontSize: "10"
          },
          data: ["2020-06-28", "", "2020-07-19", "", "2020-07-27", "", "2020-08-27"]
        },
        yAxis: {
          type: "value",
          min: "dataMin",
          max: "dataMax",
          position: "right",
          axisLabel: {
            fontSize: "10"
          },
          splitLine: {
            lineStyle: {
              color: "#f7f8fa"
            }
          }
        },
        series: [{
          data: [70454.49, 61829.13, 33203.78, 43578.42, 23953.07, 54327.71, 34327.71],
          type: "line",
          symbol: "none",
          itemStyle: {
            normal: {
              color: "rgba(2,204,135,0.8)"
            }
          },
          areaStyle: {
            normal: {
              color: "rgba(2,204,135,0.1)"
            }
          }
        }, {
          data: [80454.49, 71829.13, 43203.78, 53578.42, 33953.07, 64327.71, 44327.71],
          type: "line",
          symbol: "none",
          itemStyle: {
            normal: {
              color: "rgba(198,27,61,0.8)"
            }
          },
          areaStyle: {
            normal: {
              color: "rgba(198,27,61,0.1)"
            }
          }
        }]
      }
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    language: "user/language",
    userInfo: "user/userInfo"
  })), {}, {
    title: function title() {
      var title = "数字货币银行";

      if (_stationSetting.VUE_APP_ID == "9wZvazddcsWrnWtnB7Zhy399") {
        title = "数字理财平台";
      } else {
        title = "数字货币银行";
      }

      var val = this.marketInfoShow.last + "  " + this.coinFrom.toUpperCase() + "  " + this.translateTitle("永续") + "/" + this.coinTo.toUpperCase() + " " + this.translateTitle(title);
      return val;
    },
    marketInfoShow: function marketInfoShow() {
      var _this = this;

      var tempMarketInfo = {
        last: "",
        currency: {
          cny: ""
        }
      };
      this.marketList.forEach(function (ele) {
        if (ele.symbol_id == _this.swap_symbol_id) {
          tempMarketInfo = ele;
        }
      });
      return tempMarketInfo;
    }
  }),
  created: function created() {
    var _this2 = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var tempCookies;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.getUrlSymbol();

            case 2:
              _context.next = 4;
              return _this2.getExchangeItemId();

            case 4:
              tempCookies = _jsCookie.default.get("topcredit_exchange_t");

              if (!(tempCookies == undefined)) {
                _context.next = 11;
                break;
              }

              _context.next = 8;
              return _this2.initURL();

            case 8:
              _this2.initWs();

              _context.next = 15;
              break;

            case 11:
              _this2.token = _jsCookie.default.get("topcredit_exchange_t");
              _context.next = 14;
              return _this2.initURL();

            case 14:
              _this2.initWs();

            case 15:
              _this2.resolveCoin(); // this.voucherInterval = setInterval(() => {
              //   document.title = this.title;
              // }, 500);


            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {
    clearInterval(this.voucherInterval);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.voucherInterval);
  },
  watch: {
    userInfo: function userInfo(newValue, oldValue) {
      var _this3 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var tempUserInfo;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this3.userInfo == null)) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 3;
                return _this3.getToken();

              case 3:
                _context2.next = 5;
                return _this3.initURL();

              case 5:
                _this3.initWs();

                _context2.next = 15;
                break;

              case 8:
                tempUserInfo = sessionStorage.getItem("userInfo");

                if (!tempUserInfo) {
                  _context2.next = 11;
                  break;
                }

                return _context2.abrupt("return");

              case 11:
                _this3.token = _jsCookie.default.get("topcredit_exchange_t");
                _context2.next = 14;
                return _this3.initURL();

              case 14:
                _this3.initWs();

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  },
  methods: {
    routeSplicing: _routeSplicing.default,
    doSwitch: function doSwitch() {
      var that = this;
      this.isSwitchImg = !this.isSwitchImg;
      this.isSwitch = true;
      setTimeout(function () {
        that.isSwitch = false;
      }, 2000);
    },
    isShowCurrency: function isShowCurrency() {
      this.currencyShow = true;
    },
    isShowExchange: function isShowExchange() {
      var _this4 = this;

      this.exchangeShow = true;
      this.$nextTick(function () {
        var max_series0 = Math.max.apply(Math, (0, _toConsumableArray2.default)(_this4.currencyOptions.series[0].data).concat((0, _toConsumableArray2.default)(_this4.currencyOptions.series[1].data)));
        var min_series0 = Math.min.apply(Math, (0, _toConsumableArray2.default)(_this4.currencyOptions.series[0].data).concat((0, _toConsumableArray2.default)(_this4.currencyOptions.series[1].data)));
        _this4.currencyOptions.yAxis.interval = (max_series0 - min_series0) / 5;

        _this4.$refs.currencychart.setOption(_this4.currencyOptions);
      });
    },
    onClosePosition: function onClosePosition() {
      this.$confirm(this.translateTitle("确认平仓该订单?"), this.translateTitle("平仓"), {
        confirmButtonText: this.translateTitle("确定"),
        cancelButtonText: this.translateTitle("取消")
      }).then(function () {});
    },
    onMinClick: function onMinClick() {
      this.multipleNum -= 1;

      if (this.multipleNum <= 1) {
        this.multipleNum = 1;
      }
    },
    onPlusClick: function onPlusClick() {
      this.multipleNum += 1;

      if (this.multipleNum >= 300) {
        this.multipleNum = 300;
      }
    },
    goToLogin: function goToLogin() {
      this.$router.push({
        path: this.routeSplicing(this.language, "login"),
        query: {
          redirect: this.$route.fullPath
        }
      });
    },
    goToRegister: function goToRegister() {
      this.$router.push(this.routeSplicing(this.language, "register"));
    },
    formatTooltip: function formatTooltip(val) {
      return val + "X";
    },
    onInputChange: function onInputChange(value) {
      if (Number(value) > Number(this.maxNumber[this.swap_symbol_id])) {
        value = this.maxNumber[this.swap_symbol_id];
      }

      this.sliderValue = Number(value);
      this.multipleNum = value;
    },
    onSliderChange: function onSliderChange(value) {
      this.multipleNum = value;
    },
    handleClose: function handleClose() {
      this.multipleNum = 20;
      this.dialogVisible = false;
    },
    onMultipleNumClick: function onMultipleNumClick(value) {
      var _this5 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, _yield$apiGetOrderSta, status, data, msg;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.sliderValue = Number(value);
                _this5.multipleNum = value;
                params = {
                  symbol_id: _this5.swap_symbol_id
                };
                _context3.next = 5;
                return (0, _order.apiGetOrderStatistic)(params);

              case 5:
                _yield$apiGetOrderSta = _context3.sent;
                status = _yield$apiGetOrderSta.status;
                data = _yield$apiGetOrderSta.data;
                msg = _yield$apiGetOrderSta.msg;

                if (status == 200) {
                  _this5.historyDataLength = data.contract_position_info.total_num + data.contract_plan_info.total_num;

                  if (_this5.historyDataLength == 0) {
                    _this5.dialogVisible = true;
                  } else {
                    (0, _message.showMessage)({
                      message: _this5.translateTitle("当前有进行中的仓位或委托单，不能修改杠杆倍数"),
                      type: "error"
                    });
                  }
                } else {
                  (0, _message.showMessage)({
                    message: msg,
                    type: "error"
                  });
                }

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onMultipleNumConfirm: function onMultipleNumConfirm() {
      // localStorage.setItem("stock-multiple-num", Number(this.multipleNum));
      // this.resetSetItem("stock-multiple-num", Number(this.multipleNum));
      this.$refs.panelComponent.setMultipleNum(Number(this.multipleNum));
      this.$refs.tradeComponent.setMultipleNum(Number(this.multipleNum));
      this.dialogVisible = false;
    },
    onAddOption: function onAddOption() {
      this.$refs.marketComponent.getOptionList();
    },
    onMarketAddOption: function onMarketAddOption() {
      this.$refs.panelComponent.getOptionList();
    },
    onAreaChange: function onAreaChange(item) {
      this.currIndex = item.value;
    },
    onTradeSuccess: function onTradeSuccess(type) {
      this.$refs.historyOrder.reset(type);
    },
    getExchangeItemId: function getExchangeItemId() {
      var _this6 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _yield$apiGetStaticTa, status, data;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(13);

              case 2:
                _yield$apiGetStaticTa = _context4.sent;
                status = _yield$apiGetStaticTa.status;
                data = _yield$apiGetStaticTa.data;

                if (status == 200) {
                  _this6.coinItemIdMap = JSON.parse(JSON.stringify(data));
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    getUrlSymbol: function getUrlSymbol() {
      var _this7 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _yield$apiGetStaticTa2, status, data, tempSymbol, _loop, key;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(49);

              case 2:
                _yield$apiGetStaticTa2 = _context5.sent;
                status = _yield$apiGetStaticTa2.status;
                data = _yield$apiGetStaticTa2.data;

                if (status == 200) {
                  _this7.coinInfoMap = JSON.parse(JSON.stringify(data));
                  tempSymbol = _this7.$route.params.symbol;

                  if (!tempSymbol) {
                    tempSymbol = "btcusdt";
                    _this7.symbol = "btcusdt";
                  } else {
                    _this7.symbol = tempSymbol;
                  }

                  _loop = function _loop(key) {
                    var tempArr = [];
                    tempArr = _this7.coinInfoMap[key].leverage_list.split(",");
                    _this7.maxMultipleNum = tempArr[tempArr.length - 1];
                    var tempBase = tempArr[tempArr.length - 1] / 5;
                    _this7.marks[key] = {}; // this.maxNumber[key] = {};

                    _this7.maxNumber[key] = tempArr[tempArr.length - 1];
                    tempArr.forEach(function (ele, index) {
                      _this7.marks[key][1] = "1X";
                      _this7.marks[key][tempBase * (index + 1)] = tempBase * (index + 1) + "X";
                    });

                    _this7.tradePairArray.push(_this7.coinInfoMap[key].symbol.toLowerCase());

                    if (_this7.coinInfoMap[key].symbol.toLowerCase() == tempSymbol) {
                      _this7.swap_symbol_id = _this7.coinInfoMap[key].symbol_id;
                      _this7.from_item_id = _this7.coinInfoMap[key].change_item_id;
                      _this7.to_item_id = _this7.coinInfoMap[key].base_item_id;
                    }
                  };

                  for (key in _this7.coinInfoMap) {
                    _loop(key);
                  }
                }

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    onSymbolChangeV2: function onSymbolChangeV2(params) {
      this.$refs.marketComponent.onSymbolChange(params, "1");
    },
    onSymbolChange: function onSymbolChange(item) {
      if (this.swap_symbol_id == item.symbol_id) {
        return;
      }

      this.old_swap_symbol_id = this.swap_symbol_id;
      window.ws.sub({
        action: "Topic.unsub",
        data: {
          type: "order",
          symbol: this.swap_symbol_id
        }
      });
      this.orderbookList = [];
      window.ws.sub({
        action: "Topic.sub",
        data: {
          type: "order",
          symbol: item.symbol_id
        }
      });
      window.ws.sub({
        action: "Topic.unsub",
        data: {
          type: "depth",
          symbol: this.swap_symbol_id
        }
      });
      this.depthList = {
        a: [["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"]],
        b: [["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"]]
      };
      window.ws.sub({
        action: "Topic.sub",
        data: {
          type: "depth",
          symbol: item.symbol_id
        }
      });
      this.$refs.klineComponent.onChangeSymbol(item);
      this.swap_symbol_id = item.symbol_id;
      this.from_item_id = item.change_item_id;
      this.to_item_id = item.base_item_id;
      this.resolveCoin(); // this.$refs.historyOrder.resetV2();
    },
    resolveCoin: function resolveCoin() {
      var _this8 = this;

      this.pageLoading = true;
      var tempSymbol = this.$route.params.symbol;

      if (!tempSymbol) {
        tempSymbol = "btcusdt";
        this.swap_symbol_id = 100901;
      }

      var trade_pair = tempSymbol;

      if (this.tradePairArray.indexOf(trade_pair.toLowerCase()) == -1) {
        tempSymbol = "btcusdt";
        this.swap_symbol_id = 100901;
      }

      this.coinFrom = this.coinItemIdMap[this.from_item_id].item_name.toUpperCase();
      this.coinTo = this.coinItemIdMap[this.to_item_id].item_name.toUpperCase(); // const [coinFrom, coinTo] = tempSymbol.split("_");
      // this.coinFrom = coinFrom;
      // this.coinTo = coinTo;

      setTimeout(function () {
        _this8.pageLoading = false;
      }, 300);
    },
    getToken: function getToken() {
      var _this9 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _yield$apiGetDefaultT, status, data;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return (0, _index2.apiGetDefaultToken)();

              case 2:
                _yield$apiGetDefaultT = _context6.sent;
                status = _yield$apiGetDefaultT.status;
                data = _yield$apiGetDefaultT.data;

                if (status == 200) {
                  _this9.token = data.token;
                }

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    initURL: function initURL() {
      var _this10 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var params, _yield$apiWsUrl, status, data;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                params = {
                  __version: "3.4.3" // token: this.token,

                };
                _context7.next = 3;
                return (0, _index2.apiWsUrl)(params);

              case 3:
                _yield$apiWsUrl = _context7.sent;
                status = _yield$apiWsUrl.status;
                data = _yield$apiWsUrl.data;

                if (status == 200) {
                  _this10.wsUrl = data.ws3_url;
                }

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    initWs: function initWs() {
      var me = this;
      var option = {
        url: this.wsUrl,
        subData: {
          action: "Topic.sub",
          data: {
            type: "kline",
            resolution: "15",
            symbol: me.swap_symbol_id
          }
        },
        callback: callback,
        onConnect: onConnect,
        mounted: mounted
      };
      window.ws = new _socket.default(option).getInstance(); // 重新连接

      function onConnect() {
        if (me.wsContentTime > 3) {
          window.location.reload();
        }

        setTimeout(function () {
          me.wsContentTime++;
          me.initWs();
        }, 3000);
      }

      function mounted() {
        window.ws.sub({
          action: "Topic.sub",
          data: {
            type: "market",
            symbol: me.swap_symbol_id
          }
        });
        window.ws.sub({
          action: "Topic.sub",
          data: {
            type: "depth",
            symbol: me.swap_symbol_id // resolution: "D",

          }
        });
        window.ws.sub({
          action: "Topic.sub",
          data: {
            type: "order",
            symbol: me.swap_symbol_id
          }
        });
        window.ws.sub({
          action: "Topic.sub",
          data: {
            // type: "contractM",
            type: "stock",
            app_id: _stationSetting.VUE_APP_ID
          }
        });

        if (_jsCookie.default.get("topcredit_exchange_t")) {
          window.ws.sub({
            action: "Topic.sub",
            data: {
              type: "assets"
            }
          });
        }
      }

      function callback(data) {
        var action = data.action;

        if (action == "Pushdata.stock") {
          // if (action == "Pushdata.market") {
          if (data.data) {
            var tempArr = data.data;
            tempArr.forEach(function (ele) {
              ele.lastV2 = Number(ele.last);

              if (!ele["currency"]) {
                ele["currency"] = {};
              }

              ele.currency.usdV2 = JSON.stringify(ele.currency) != "{}" ? Number(ele.currency.usd) : 0;
              ele.price_change_percentV2 = Number(ele.price_change_percent);
            });
            me.marketList = tempArr;
          }
        }

        if (action == "Pushdata.kline") {
          window.resolveKlineDataV3(data);
        } // 资产


        if (action == "Pushdata.assets") {
          if (data.data == null || data.data instanceof Array) {
            return;
          }

          me.assetsInfo = data.data;
        }

        if (action == "Pushdata.orderbook") {
          if (data.data) {
            var _me$orderbookList;

            if (!data.params.p || data.params.p == me.old_swap_symbol_id) {
              return;
            }

            (_me$orderbookList = me.orderbookList).unshift.apply(_me$orderbookList, (0, _toConsumableArray2.default)(data.data));

            if (me.orderbookList.length > 28) {
              me.orderbookList = me.orderbookList.slice(0, 28);
            }
          }
        }

        if (action == "Pushdata.depth") {
          if (data.data) {
            if (!data.params.p || data.params.p == me.old_swap_symbol_id) {
              return;
            }

            var tempObj = data.data;

            if (tempObj.a.length > 0) {
              tempObj.c = 0;
              tempObj.d = 0;
              tempObj.a.forEach(function (ele) {
                tempObj.c += Number(ele[1]);
              });
              tempObj.b.forEach(function (ele) {
                tempObj.d += Number(ele[1]);
              });
            }

            me.depthList = tempObj;
          }
        }
      }
    }
  }
};
exports.default = _default;